import { categoryImageContexts } from "../constants/categoryImageContexts";

function resolveModule(mod) {
  if (mod == null) return null;
  return mod.default !== undefined ? mod.default : mod;
}

function basenameToAlt(filename) {
  return filename
    .replace(/\.[^/.]+$/, "")
    .replace(/\s*[-–—_]\s*/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * Loads images from a category's folder (via webpack context).
 * Picks a hero image: first filename containing "banner" (case-insensitive), else first file sorted by name.
 * Gallery = all other images sorted by name.
 *
 * @param {string} categoryKey — key in {@link categoryImageContexts}
 * @returns {{ bannerSrc: string | null, gallery: Array<{ src: string, alt: string }> }}
 */
export function getCategoryAssets(categoryKey) {
  const loader = categoryImageContexts[categoryKey];
  if (!loader) {
    return { bannerSrc: null, gallery: [] };
  }

  const keys = loader.keys();
  if (keys.length === 0) {
    return { bannerSrc: null, gallery: [] };
  }

  const entries = keys
    .map((key) => {
      const src = resolveModule(loader(key));
      const filename = key.replace(/^\.\//, "");
      return { key, src, filename };
    })
    .filter((e) => typeof e.src === "string" && e.src.length > 0);

  if (entries.length === 0) {
    return { bannerSrc: null, gallery: [] };
  }

  const sorted = [...entries].sort((a, b) =>
    a.filename.localeCompare(b.filename, undefined, { sensitivity: "base" }),
  );

  const bannerCandidates = sorted.filter((e) => /banner/i.test(e.filename));
  const bannerEntry =
    bannerCandidates.length > 0 ? bannerCandidates[0] : sorted[0];

  const bannerSrc = bannerEntry.src;

  const gallery = sorted
    .filter((e) => e.key !== bannerEntry.key)
    .map((e) => {
      const stem =
        e.filename.replace(/\.[^/.]+$/, "").split(/\s+-\s+/)[0]?.trim() || "";
      return {
        src: e.src,
        alt: basenameToAlt(e.filename) || "Event image",
        pairingKey: stem,
      };
    });

  return { bannerSrc, gallery };
}
